
  <mat-dialog-content>
    <h2>Результат проверки фильтра</h2>
    <div>Синтаксис: <span [ngClass]="{error: !syntaxCorrect, success: syntaxCorrect}" [matTooltip]="tooltip">{{ syntaxCorrect ? 'корректно' : 'ошибка' }}</span></div>
    <div *ngIf="checkResult.checked">
      <div>Логика: <span [ngClass]="{error: !logicCorrect, success: logicCorrect}">{{ logicCorrect ? 'корректно' : 'ошибка'  }}</span></div>
      <div class="result-text">{{ checkResult.text }}</div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
      <button mat-raised-button
              (click)="close()"
              color="primary">Закрыть</button>
  </mat-dialog-actions>

